/* eslint-disable react/display-name */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import Footer from '@Components/Footer';

import './RsTable.theme.scss';

const RsTable = React.forwardRef((props, ref) => {
  const {
    isLoading,
    dataList,
    header = null,
    placement,
    renderItem = () => null,
    className,
    wrapperClassName,
    containerClassName,
    children,
    showFooter,
  } = props;
  const noFooterClass = !showFooter ? 'rs-table-without-footer' : undefined;
  const placementHeight = showFooter || placement === 'docked_right' ? '' : 'rs-table-placement-height';

  return (
    <div className={cn(wrapperClassName, { 'rs-table-wrapper': showFooter })}>
      <div ref={ref} className={cn('rs-table-container', containerClassName, noFooterClass, placementHeight)}>
        <p id="route-topology-sr" className="sr-only">
          This column shows the Route topology thumbnail, providing a quick overview of the complexity of the found route.
        </p>
        <p id="building-block-sr" className="sr-only">
          This column shows the Building Blocks to target column shows building blocks/starting materials required to synthesize the given
          target compound, and number of steps in each route.
        </p>
        <table
          className={cn(
            'table c-els-table c-els-table--middle c-els-table--vertical-dividers c-els-table--subtle-dividers rs-table',
            className
          )}
          aria-label="RT Table with the reaction and view details">
          <thead className="c-els-table__head">{header}</thead>
          <tbody className="c-els-table__body">
            {isLoading && (
              <tr>
                <td>
                  <SimpleSpinner />
                </td>
              </tr>
            )}
            {dataList &&
              dataList.map((projectVO, i) => {
                const stableKey = projectVO && (projectVO.id || projectVO.key || projectVO.uuid);
                return <React.Fragment key={stableKey || `project-item-fallback-${i}`}>{renderItem(projectVO, i)}</React.Fragment>;
              })}
          </tbody>
        </table>
        {children}
      </div>
      {showFooter && <Footer className="retro-synthesis-footer" />}
    </div>
  );
});

RsTable.propTypes = {
  isLoading: PropTypes.bool,
  dataList: PropTypes.array,
  header: PropTypes.node,
  showFooter: PropTypes.bool,
  renderItem: PropTypes.func,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  containerClassName: PropTypes.string,
};

export default RsTable;
